<template>
    <div>
        <nav-breadcrumb :menu="[{label: ' 面签预约'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import moment from 'moment'
    export default {
        name: "BranchAppointmentViewList",
        data(){
            return{
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '预约编号',
                        field: 'a__appointmentNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'ba__customerName'
                    },
                    {
                        label: '身份证号码',
                        field: 'ba__customerIC'
                    },
                    {
                        label: '分公司',
                        field: 'bo__branchName'
                    },
                    {
                        label: '面签时间',
                        field: 'a__signingTime',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }

                    },
                    {
                        label: '面签室',
                        field: 'r__roomName'
                    },
                    {
                        label: '状态',
                        field: 'n__signingStatus',
                        formatter: function (r,c,v) {
                            if(v)
                                return   Status2CN('s__'+v)
                            else
                                return   Status2CN('a__'+r.a__appointmentStatus)
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'view',
                                            query: {
                                                appointmentId: row.a__appointmentId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '查看面签详情',
                                class: 'el-icon-document',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'signing',
                                            query: {
                                                transactionId: row.fi__transactionId
                                            }
                                        }
                                    )
                                },
                                conditions: row=> {
                                    return   row.fi__transactionId

                                }
                            },
                            {
                                label: '盖公章',
                                class: 'el-icon-coin',
                                clickHandler: (index, row)=> {
                                    xhr.JxSign1( {
                                        't.appointmentId': row.a__appointmentId,
                                    }, res=> {
                                        try {
                                            if (res.data.status == 'success') {
                                                this.$message.success("盖章成功")
                                                this.getData()
                                            }
                                        } catch (e) {
                                        }
                                    })
                                },
                                conditions: row=> {
                                    return  this.tableData.variables.jsSigner1==this.$store.state.userInfo.u__userId&&row.n__jxSealSigner1==null&&row.n__signingStatus=='Completing'

                                }
                            },
                            {
                                label: '盖法人章',
                                class: 'el-icon-files',
                                clickHandler: (index, row)=> {
                                    xhr.JxSign2( {
                                        't.appointmentId': row.a__appointmentId,
                                    }, res=> {
                                        try {
                                            if (res.data.status == 'success') {
                                                this.$message.success("盖章成功")
                                                this.getData()
                                            }
                                        } catch (e) {
                                        }
                                    })
                                },
                                conditions: row=> {
                                    return this.tableData.variables.jsSigner2==this.$store.state.userInfo.u__userId&&row.n__jxSealSigner2==null&&row.n__signingStatus=='Completing'

                                }
                            },
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        a__appointmentNo:'',
                        ba__customerName:'',
                        bo__branchId:'',
                        a__signingTime:[],
                        a__appointmentStatus:'',
                    },
                    columns: [

                        {
                            label: '预约编号',
                            component: 'el-input',
                            field: 'a__appointmentNo',
                            span:8
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'ba__customerName',
                            span:8
                        },
                        {
                            label: '分公司',
                            component: 'el-select',
                            field: 'bo__branchId',
                            options: [],
                            span: 8
                        },
                        {
                            label: '面签日期',
                            component: 'date-range-picker',
                            field: 'a__signingTime',
                            op: ['gteq', 'lteq'],
                            span: 16
                        },
                        {
                            label: '状态',
                            component: 'el-select',
                            field: 'a__appointmentStatus',
                            op:'eq',
                            options: [
                                {
                                    label:'待审核',
                                    value:'Pending Approval',
                                },
                                {
                                    label:'待面签',
                                    value:'Approved',
                                },
                                {
                                    label:'审核不通过',
                                    value:'Rejected',
                                },
                                {
                                    label:'面签完成',
                                    value:'Completed',
                                },
                                {
                                    label:'面签中',
                                    value:'Signing',
                                },
                                {
                                    label:'面签完成、待用印',
                                    value:'Completing',
                                },
                                {
                                    label:'面签取消',
                                    value:'Cancelled',
                                },
                                {
                                    label:'已过期',
                                    value:'Expired',
                                },
                            ],
                            span: 8
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
            this.getDataBranchOfficeSelect()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.sort.dataField': 'a.signingTime',
                    'xlist.sort.order': 'desc'
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getBranchAppointmentList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
            getDataBranchOfficeSelect: function () {
                xhr.getDataBranchOfficeSelect(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            this.filters.columns[2].options = res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            removeItem: function (index, row) {
                removeItem(
                    xhr.deleteBranchOffice,
                    {
                        'bo.branchId' : row.bo__branchId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchAppointmentViewList.vue